import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/forgot-password-form.tsx");
